import styled from 'styled-components';

export const Timebar = styled.div`
  width: calc(100% + 48px);
  height: 2px;
  background-color: ${({ theme }) => theme.colors.badgeActive};
  position: relative;
  top: 66px;

  @media ${(props) => props.theme.device.tablet} {
    width: 100%;
  }
`;

export const TimelineContainer = styled.div`
  display: flex;
  position: relative;
  padding-top: 66px;

  @media ${(props) => props.theme.device.tablet} {
    padding-top: 50px;
  }
`;

export const TimeCard = styled.div`
  min-width: 40%;
  padding-right: 68px;
  padding-top: 34px;
  position: relative;
  z-index: 1;

  @media ${(props) => props.theme.device.tablet} {
    min-width: 100%;
    padding-right: 16px;
    padding-top: 52px;
  }

  .time-dot {
    position: absolute;
    width: 36px;
    height: 36px;
    left: 0;
    top: -18px;
    background: #ffffff;
    border: 5px solid #22408b;
    border-radius: 100%;

    @media ${(props) => props.theme.device.tablet} {
      top: -4px;
    }
  }
`;
